// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}
	const {session} = props;
	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (session.isCompany) {
		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
			&& fields.customer_address_street.length > 0
			&& fields.customer_address_zipcode.length > 0
			&& fields.customer_address_city.length > 0
			&& Validator.validateEmail(fields.customer_email)
		);
	}

	return !!(
		fields.customer_firstname.length > 0
		&& fields.customer_lastname.length > 0
		&& Validator.validateSsn(fields.customer_social_security_number)
		&& fields.customer_address_street.length > 0
		&& fields.customer_address_zipcode.length > 0
		&& fields.customer_address_city.length > 0
		// && fields.customer_phonenumber_cell.length > 0
		&& Validator.validateEmail(fields.customer_email)
	);

}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/fair-ag/CustomerInformation.fulfillment.js